<div class="user-list">
  <p class="permission-label">
    <b>{{ name }}</b>
  </p>
  <ul>
    <ng-container *ngIf="showGroupedByYear; else flatList">
      <ng-container *ngFor="let group of categorizedByFilingYear | keyvalue">
        <li
          *ngIf="editing || shouldShowCollapseArrow(group.key)"
          (click)="toggleYear(group.key)"
          [ngClass]="{
            'filing-years':
              !hideCollapsedArrow && shouldShowCollapseArrow(group.key)
          }"
        >
          <div
            class="icon-container"
            [ngClass]="{
              hidden:
                isYearExpanded(group.key) ||
                hideCollapsedArrow ||
                !shouldShowCollapseArrow(group.key)
            }"
          >
            <i class="fa fa-chevron-down"></i>
          </div>
          <div
            class="icon-container"
            [ngClass]="{
              hidden:
                !isYearExpanded(group.key) ||
                hideCollapsedArrow ||
                !shouldShowCollapseArrow(group.key)
            }"
          >
            <i class="fa fa-chevron-up"></i>
          </div>
          <strong>{{ group.key }}</strong>
        </li>
        <ng-container *ngIf="isYearExpanded(group.key)">
          <ng-container *ngFor="let item of group.value">
            <li
              *ngIf="
                permissionList.indexOf(item.id) >= 0 ||
                item.allowAllDesignee ||
                editing
              "
              (click)="addToPermissionList(item, permissionList)"
              [ngClass]="{
                selected:
                  permissionList.indexOf(item.id) >= 0 || item.allowAllDesignee
              }"
            >
              <div class="user-list-item">
                <div class="uk-flex ukflex-nowrap">
                  <div class="custom-checkbox">
                    <i class="fas fa-circle"></i>
                    <i class="fas fa-check"></i>
                  </div>
                  <div class="user-name" *ngIf="label !== 'dateSigned'">
                    {{ item[label] }}
                  </div>
                  <div class="user-name" *ngIf="label === 'dateSigned'">
                    {{ item[label] | date : "medium" }}
                  </div>
                </div>
              </div>
            </li>
          </ng-container>
        </ng-container>
      </ng-container>
    </ng-container>

    <ng-template #flatList>
      <ng-container *ngFor="let item of cardList">
        <li
          *ngIf="
            permissionList.indexOf(item.id) >= 0 ||
            item.allowAllDesignee ||
            editing
          "
          (click)="addToPermissionList(item, permissionList)"
          [ngClass]="{
            selected:
              permissionList.indexOf(item.id) >= 0 || item.allowAllDesignee
          }"
        >
          <div class="user-list-item">
            <div class="uk-flex ukflex-nowrap">
              <div class="custom-checkbox">
                <i class="fas fa-circle"></i>
                <i class="fas fa-check"></i>
              </div>
              <div class="user-name" *ngIf="label !== 'dateSigned'">
                {{ item[label] }}
              </div>
              <div class="user-name" *ngIf="label === 'dateSigned'">
                {{ item[label] | date : "medium" }}
              </div>
            </div>
          </div>
        </li>
      </ng-container>
    </ng-template>
  </ul>
</div>
